import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { BdGrantRequestsService } from '@bindoc-projects/bindoc-permissions-lib/data';
import { BadgeModule } from 'primeng/badge';
import { ButtonDirective, ButtonIcon } from 'primeng/button';

@Component({
  selector: 'bd-notification-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a routerLink="/user/notifications" class="relative inline-flex">
      <button pButton text rounded size="small" aria-label="Benachrichtigungen">
        <i class="pi pi-bell" pButtonIcon></i>
      </button>
      @if (count() > 0) {
        <p-badge
          [value]="count().toString()"
          severity="danger"
          class="absolute top-0 right-0"
        ></p-badge>
      }
    </a>
  `,
  imports: [RouterLink, ButtonDirective, ButtonIcon, BadgeModule],
})
export class BdNotificationBadgeComponent {
  private readonly _grantRequestsService = inject(BdGrantRequestsService);

  public readonly count = toSignal(this._grantRequestsService.inboxCount$, {
    initialValue: 0,
  });
}
